import throttle from 'lodash/throttle';
import $ from 'jquery';

let lastScroll = 0;

class SystemNavigationDropdown {
  constructor(button, systemNav) {
    this.activeClass = 'is-active';
    this.openClass = 'is-open';
    this.button = button;
    this.systemNav = systemNav;

    this.button.addEventListener('click', this.handleClick);
    window.addEventListener('scroll', throttle(this.handleScroll, 200));
  }

  handleClick = () => {
    this.button.classList.toggle(this.activeClass);
    this.systemNav.classList.toggle(this.openClass);
  };

  handleScroll = () => {
    const scroll = $(window).scrollTop();
    if ($(window).scrollTop() > lastScroll || $(window).scrollTop() === 0) {
      this.systemNav.classList.remove(this.activeClass);
      this.systemNav.classList.remove(this.openClass);
      this.button.classList.remove(this.activeClass);
    } else {
      this.systemNav.classList.add(this.activeClass);
    }
    lastScroll = scroll;
  }
}

$(document).ready(() => {
  const button = document.querySelector('.js-system-navigation-dropdown');
  const systemNav = document.querySelector('.js-system-navigation');

  if (button !== null && systemNav !== null) {
    /* eslint-disable no-new */
    new SystemNavigationDropdown(button, systemNav);
    /* eslint-enable no-new */
  }
});
